import React, { useEffect, useRef, useState } from 'react'
import {
  getType,
  getOperationView,
  getProducer,
  textTypes,
  makeParamsGetByFilters,
  makeFormDataByFilters,
  makeParamsCoordinates,
  makeParamsByFiltersMediacore,
} from '@helpers/helper.filters'
import { graphql, useStaticQuery } from 'gatsby'
import { connect, useDispatch, useSelector } from 'react-redux'
import { reduxUpdateOrderBy } from '@slices/propertiesSlice'
import useQueryProperties from '@hooks/useQueryProperties'
import { RealEstateDataPageComponentData, StatePropertiesSlice } from 'types'
import $ from 'jquery'

const HeaderResults = ({ global_data, is_wide, type, includeTag}: RealEstateDataPageComponentData) => {
  const {
    filters,
    offset,
    orders,
    coordinates,
    polygonCoordinates,
    selected,
    viewId, // map,
  }: StatePropertiesSlice = useSelector(
    (state: { properties: StatePropertiesSlice }) => state.properties,
  )

  const MediaPro = true
  const selectorOrder = useRef<any>()
  const dispatch = useDispatch()

  const API_KEY = global_data.pageConfig.keys.tokko
  const {
    properties,
    isLoading: isLoadingProperties,
    isFetching: isFetchingProperties,
  } = useQueryProperties({
    filters,
    coordinates,
    polygonCoordinates,
    orders,
    offset,
    tokkoKey: API_KEY,
    custom_tags: includeTag ? includeTag.map((tag) => Number(tag)) : [],
  })

  function traductorSelect() {
    switch (selectorOrder.current.value) {
      case '0':
        dispatch(reduxUpdateOrderBy({ order: 'desc', order_by: 'price' }))
        break
      case '1':
        dispatch(reduxUpdateOrderBy({ order: 'asc', order_by: 'price' }))
        break
      case '2':
        dispatch(reduxUpdateOrderBy({ order: 'desc', order_by: 'id' }))
        break
      case '3':
        dispatch(reduxUpdateOrderBy({ order: 'asc', order_by: 'id' }))
        break
      case '4':
        dispatch(reduxUpdateOrderBy({ order: 'desc', order_by: 'total_surface' }))
        break
      case '5':
        dispatch(reduxUpdateOrderBy({ order: 'asc', order_by: 'total_surface' }))
        break
    }
  }

  useEffect(() => {
    if (screen.width < 992) {
      const height = $('#header').height()! + $('.handle-filter-bar.a').height()!
      $('.sticky-top-custom').css('position', 'sticky')
      $('.sticky-top-custom').css('z-index', '9')
      const header: any = document.querySelector('header')
      // if (header?.classList?.contains('position-fixed')) {
      $('.sticky-top-custom').css('top', height)
      $('#handle-filter-bar').css('top', height - $('.handle-filter-bar.a').height()!)
      // } else {
      //   $('.sticky-top-custom').css('top', $('#handle-filter-bar').height()!)
      // }
    }
  }, [isFetchingProperties])

  return (
    (viewId === 2 || viewId === 1) && (
      <div className={'sticky-top-custom ' + (is_wide ? 'col-lg-12' : 'col-lg-11 ')}>
        <div
          id="header-results-b"
          className={
            'p-y-config ' + (is_wide ? '' : 'container-fluid') + (type ? ' is-summary-style' : '')
          }
        >
          <div className="row align-items-end">
            <div className="col-12"></div>
            <div className="col-lg-6 mt-0 mt-lg-0">
              <div className="section-title pt-0 pt-lg-0 pb-lg-0">
                <p
                  className={
                    (isLoadingProperties && 'skeleton my-2') + ' text-uppercase mb-lg-4 mb-3 '
                  }
                >
                  {isLoadingProperties || isFetchingProperties
                    ? 'Cargando'
                    : properties?.meta.total_count}{' '}
                  resultados totales de búsqueda.{' '}
                </p>
                <h2
                  className={
                    !getOperationView(filters) ? 'mt-lg-3 skeleton' : 'mb-0 text-uppercase'
                  }
                >
                  {'Propiedades'} en{' '}
                  <div className="d-inline-block text-secondary">{getOperationView(filters)} </div>
                  <div className="d-inline-block text-capitalize">{getProducer(filters)}</div>
                </h2>
                <br className="d-lg-none" />
              </div>
            </div>
            {!MediaPro && (
              <div className="col-6 d-none d-lg-flex align-items-center justify-content-end">
                <p
                  // onClick={() => document.body.classList.toggle('overflow-hidden') + setMenu(!menu)}
                  id="openFilter"
                  className="d-lg-flex d-none align-items-center justify-content-end"
                >
                  <i className="icon-filters me-4"></i>
                  <h4 className="mb-0">FILTROS DE BÚSQUEDA</h4>
                </p>
              </div>
            )}
            <div
              className="col-lg-6 justify-content-end d-flex align-items-center mt-lg-2 mb-lg-2"
              id="orderBy"
            >
              <p className="me-lg-4 me-3">Ordenar por:</p>
              <div
                className="content-select text-end me-0"
                style={{ borderRadius: type ? type : '', padding: type ? '10px 7px' : '' }}
              >
                <select
                  ref={selectorOrder}
                  onChange={() => traductorSelect()}
                  className="text-end me-lg-0"
                  style={{ borderRadius: type ? type : '' }}
                  name="orderby"
                  id="sort"
                >
                  <option value="2">Publicaciones más recientes</option>
                  <option value="3">Publicaciones más antiguas</option>
                  <option value="0">Mayor precio</option>
                  <option value="1">Menor precio</option>
                  <option value="4">Mayor superficie</option>
                  <option value="5">Menor superficie</option>
                </select>
                <i></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  )
}

export default HeaderResults
